import dayjs from 'dayjs';
import { SpeakToTextDto } from 'types';

export const getPropsSpeakToTextItem = (
  message: SpeakToTextDto,
  nextMess?: SpeakToTextDto | null,
  prevMess?: SpeakToTextDto | null
) => {
  return {
    isOnSameDate: prevMess ? dayjs(message.createdAt).isSame(prevMess.createdAt, 'date') : false,
    isLastOfSender: nextMess
      ? message.senderId !== nextMess?.senderId
      : // || nextMess.messageType === MESSAGE_TYPE.SYSTEM
        true,
    isFirstOfSender: prevMess
      ? message.senderId !== prevMess?.senderId
      : // || (prevMess.messageType !== MESSAGE_TYPE.TEXT && prevMess.messageType !== MESSAGE_TYPE.COMMENT)
        true
  };
};
